import { render } from "./ModalContacto.vue?vue&type=template&id=35cce016&scoped=true"
import script from "./ModalContacto.vue?vue&type=script&lang=js"
export * from "./ModalContacto.vue?vue&type=script&lang=js"

import "./ModalContacto.vue?vue&type=style&index=0&id=35cce016&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cce016"]])

export default __exports__